module.exports = __webpack_public_path__ + "img/Bocabo.90191401.webp";